<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-lg-6">
          <validated-form-input name="firstName" label="Eesnimi:" placeholder="Eesnimi"
                                v-model="representative.firstName"
                                validate="required" :validator="$validator"/>

          <validated-form-input name="lastName" label="Perenimi:" placeholder="Perenimi"
                                v-model="representative.lastName"
                                validate="required" :validator="$validator"/>

          <validated-form-select name="type" :options="types" label="Tüüp:" placeholder="- Vali tüüp -"
                                 v-model="representative.type" validate="required" :validator="$validator"/>

        </div>
        <div class="col-lg-6">
          <validated-form-input name="details" label="Lisainfo:" placeholder="Lisainfo" v-model="representative.details"
                                validate=""
                                :validator="$validator"/>

          <validated-form-input name="email" label="E-mail:" placeholder="E-Mail" v-model="representative.email"
                                validate="email" :validator="$validator"/>

          <validated-form-input name="phone" label="Telefon:" placeholder="Telefon" v-model="representative.phone"
                                :validate="{regex: /^\+?[0-9 ]+$/ }" :validator="$validator"/>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <submit-button class="float-right" variant="primary">Salvesta</submit-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import ValidatedFormInput from '@/components/ValidatedFormInput'
  import ValidatedFormSelect from '@/components/ValidatedFormSelect'
  import gateway from '@/services/gateway'
  import {representativeTypes, utils} from '@/services/Configuration'

  export default {
    components: {ValidatedFormInput, ValidatedFormSelect},
    props: ['clientId', 'id'],
    data() {
      return {
        representative: {
          type: null,
        },
        types: [],
      }
    },
    created() {
      this.types = utils.asSelectOptions(representativeTypes)
      gateway.get(`/clients/${this.clientId}`)
        .then(r => {
          this.representative = r.data.representatives.find(r => r.id == this.id)
          this.$emit('title', 'Muuda esindajat: ' + this.representative.firstName + ' ' + this.representative.lastName)
        })
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          gateway.post('/clients/' + this.clientId + '/representatives/' + this.id, this.representative)
            .then(() => this.$notifications.info('Kliendi esindaja salvestatud'))
            .then(() => this.$emit('done'))
        })
      },
    }
  }
</script>
